// Breathe Music Records — embed helper.
// Hydrates SoundCloud players via oEmbed; falls back to the generic widget on
// failure. Loaded as a classic <script> by every public page.

interface OEmbedResponse {
  html?: string;
}

async function loadSoundCloudEmbed(node: HTMLElement): Promise<void> {
  const url = node.getAttribute("data-sc-url");
  if (!url) return;

  const endpoint = `https://soundcloud.com/oembed?format=json&maxheight=166&url=${encodeURIComponent(url)}`;
  try {
    const res = await fetch(endpoint, { mode: "cors" });
    if (!res.ok) throw new Error(`oEmbed HTTP ${res.status}`);
    const data = await res.json() as OEmbedResponse;
    if (!data.html) throw new Error("oEmbed missing html");
    node.innerHTML = data.html;
    // Match our styling hooks on the injected iframe.
    const iframe = node.querySelector("iframe");
    if (iframe) {
      iframe.classList.add("embed");
      iframe.setAttribute("loading", "lazy");
      iframe.setAttribute("allow", "autoplay; encrypted-media");
    }
  } catch (_e) {
    // Fall back to the generic SoundCloud widget — some tracks disable oEmbed
    // but still allow the widget, and vice versa.
    const src = `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&visual=false`;
    node.innerHTML =
      `<iframe class="embed" height="166" frameborder="0" loading="lazy" allow="autoplay; encrypted-media" src="${src}"></iframe>` +
      `<div class="embed-fallback-note">If this player won't load, the track may have embeds disabled in SoundCloud permissions. ` +
      `<a href="${url}" target="_blank" rel="noopener">Open on SoundCloud</a></div>`;
  }
}

function init(): void {
  document.querySelectorAll<HTMLElement>(".embed-sc[data-sc-url]")
    .forEach(n => { void loadSoundCloudEmbed(n); });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
